module.exports = "/img/_/_/_/assets/images/creeper/book/common//39.jpg?6a3a3e143557676b3eff2b9ac67ef5be";